<template>
	<div >
		<div class="module_title05">
			<span>最近12个月里程分析：</span>
		</div>
		<div class="ibox-content alarm_info_list" style="height:400px;">
			<mon-line-chart
			v-if="showChart"
			:lineInfo = 'monthInfo'
			></mon-line-chart>
		</div>
	</div>	
</template>

<script>
import MonLineChart from 'components/modules/carfile/MonLineChart.vue'
export default {
  	name: 'LineLComp',
  	components:{
  		MonLineChart
 	},
  	data () {
    	return {
    		showChart:false,
    	}
  	},
  	props:['monthInfo'],
  	mounted(){
  		this.showChart = true;
  	}
}

</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// LineLComp.vue?14b8266c